import {createTheme} from "@mui/material";

export default function useMUITheme () {
    const customizedTheme = createTheme({
        palette: {
            primary: {
                main: '#42296E',
                // light: will be calculated from palette.primary.main,
                // dark: will be calculated from palette.primary.main,
                // contrastText: will be calculated to contrast with palette.primary.main
            },
        },
    });

    return customizedTheme;
}